import * as SaleArticleModels from '../../models/sale-article/sale-article';
import { SaleArticleSearchModel } from '../../models/sale-article/sale-articleSearch';


export class GetList {
  static readonly type = '[SaleArticle] List';
  constructor(public Search: SaleArticleSearchModel) { }
}

export class SetSearch {
  static readonly type = '[SaleArticle] Set Search';
  constructor(public Search: SaleArticleSearchModel) { }
}

export class ResetSearch {
  static readonly type = '[SaleArticle] Reset Search';
  constructor() { }
}

export class SetListPage {
  static readonly type = '[SaleArticle] Set List Page';
  constructor(public Search: SaleArticleSearchModel) { }
}

export class GetListSummary {
  static readonly type = '[SaleArticle] GetListSummary';
  constructor(public Search: SaleArticleSearchModel) { }
}


export class GetFilteredReport {
  static readonly type = '[SaleArticle] GetFilteredReport';
  constructor(public Search: SaleArticleSearchModel) { }
}
export class DisposeSearch {
  static readonly type = '[RelocationOrder] DisposeSearch';
  constructor() { }
}
